import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import React from 'react';

import { Badge, Copy } from 'src/common/ui/components';
import { parseValidStatus } from 'src/idVerification/domain/parseValidStatus';
import { IdSubmission } from 'src/idVerification/types';

type IdVerificationStatusProps = {
  idVerification: IdSubmission;
};

export const IdVerificationStatus = ({ idVerification }: IdVerificationStatusProps) => {
  const { valid, invalidReason, updatedAt, updatedBy } = idVerification;

  // Get the status label, accounting for null values
  const statusLabel = parseValidStatus(valid) || 'Unknown';

  return (
    <>
      {valid !== null && <Badge color={valid ? 'success' : 'error'} label={statusLabel} rounded />}
      {!valid && invalidReason && <Copy variant="body1">({invalidReason})</Copy>}
      {updatedBy && updatedAt && (
        <Copy variant="body2">
          <br />
          {format(parseISO(updatedAt), 'MMMM dd, yyyy')} by {updatedBy}
        </Copy>
      )}
    </>
  );
};
